import { render, staticRenderFns } from "./SubAddress.vue?vue&type=template&id=bb3d2956&scoped=true"
import script from "./SubAddress.vue?vue&type=script&lang=js"
export * from "./SubAddress.vue?vue&type=script&lang=js"
import style0 from "./SubAddress.vue?vue&type=style&index=0&id=bb3d2956&prod&lang=scss&scoped=true"
import style1 from "./SubAddress.vue?vue&type=style&index=1&id=bb3d2956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3d2956",
  null
  
)

export default component.exports